import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ServicosJoias = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de joias";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.servicosJoias})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Joias</h1>
          <p>Para quem valoriza cada detalhe</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('joias')}</h2>
        </article>

        {/* Bloco 1: Soldas de Ouro e Prata (Geral e Romanel) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Restauração</h3>
            <h4>Solda</h4>
            <p>Solda em peças de ouro, prata e semijoias com acabamento discreto.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.soldaJoias} alt="Solda em joias de ouro e prata" />
          </div>
        </section>

        {/* Bloco 2: Aumento/Redução e Polimento */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Ajuste</h3>
            <h4>Redução e aumento</h4>
            <p>Ajuste de tamanho para encaixe confortável e proporção correta</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.ajusteJoias} alt="Redução, aumento e polimento de anéis" />
          </div>
        </section>

        {/* Bloco 3: Manutenção Geral e Limpeza (Genérico) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Acabamento</h3>
            <h4>Polimento</h4>
            <p>Restauração do brilho e acabamento da superfície da peça.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.manutencaoJoias} alt="Manutenção e limpeza profissional de joias" />
          </div>
        </section>

        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Brilho</h3>
            <h4>Banho</h4>
            <p>Aplicação de banho em ouro, prata e ródio para renovação do tom da peça</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.polimentoJoias} alt="Manutenção e limpeza profissional de joias" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de joias')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de joias')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ServicosJoias;